import React from 'react';
import { AuthLogin } from '@/components/auth';

const AuthPage: React.FC = () => {
    return <AuthLogin />;
};

export default AuthPage;
